import React, { useState } from "react";
import "@/App.css";
import { Toaster } from "./components/ui/toaster";
import Header from "./components/Header";
import Hero from "./components/Hero";
import IntroSection from "./components/IntroSection";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import Amenities from "./components/Amenities";
import Location from "./components/Location";
import Footer from "./components/Footer";
import RentalModal from "./components/RentalModal";

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="App">
      <Header onOpenModal={() => setIsModalOpen(true)} />
      <Hero />
      <IntroSection />
      <Gallery />
      <Testimonials />
      <Amenities />
      <Location />
      <Footer />
      <RentalModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
      <Toaster />
    </div>
  );
}

export default App;
